import { render } from "./AccessibilityWidget.vue?vue&type=template&id=5f714e3f"
import script from "./AccessibilityWidget.vue?vue&type=script&lang=js"
export * from "./AccessibilityWidget.vue?vue&type=script&lang=js"

import "./AccessibilityWidget.vue?vue&type=style&index=0&id=5f714e3f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__